// Catalogue des types d'inspection CSPS - Sprint 2
export const INSPECTION_TYPES = [
  { key: 'programmee',         label: 'Inspection programmee',  color: 'bg-blue-100 text-blue-800',     dot: 'bg-blue-500' },
  { key: 'inopinee',           label: 'Inspection inopinee',    color: 'bg-orange-100 text-orange-800', dot: 'bg-orange-500' },
  { key: 'visite_securite',    label: 'Visite securite',        color: 'bg-emerald-100 text-emerald-800', dot: 'bg-emerald-500' },
  { key: 'reunion_securite',   label: 'Reunion securite',       color: 'bg-purple-100 text-purple-800', dot: 'bg-purple-500' },
  { key: 'controle_specifique',label: 'Controle specifique',    color: 'bg-amber-100 text-amber-800',   dot: 'bg-amber-500' },
];

export const INSPECTION_TYPE_MAP = INSPECTION_TYPES.reduce((acc, t) => {
  acc[t.key] = t; return acc;
}, {});

export const INSPECTION_STATUTS = [
  { key: 'planifiee', label: 'Planifiee', color: 'bg-gray-100 text-gray-700' },
  { key: 'en_cours',  label: 'En cours',  color: 'bg-blue-100 text-blue-700' },
  { key: 'terminee',  label: 'Terminee',  color: 'bg-emerald-100 text-emerald-700' },
  { key: 'cloturee',  label: 'Cloturee',  color: 'bg-zinc-200 text-zinc-700' },
];

export const INSPECTION_STATUT_MAP = INSPECTION_STATUTS.reduce((acc, s) => {
  acc[s.key] = s; return acc;
}, {});
